module.exports = __webpack_public_path__ + "img/7.501d9291.png";